import * as React from "react";
import type { SVGProps } from "react";
const SvgFinanceBuilding = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24" {...props}
  >
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M21 10H3V6.994L12.152 3 21 6.861z"
      clipRule="evenodd"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M14.643 10v8M19 18v-8M14.643 10v8M19 18v-8M5 10v8M9.357 18v-8M5 10v8M9.357 18v-8"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M3 21h18v-1l-1-2H4l-1 2z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgFinanceBuilding;
